import { useState } from "react";
import { motion } from "framer-motion";
import { Closing } from "@/components/services/SecurityServiceContent";
import { EASE } from "@/lib/site";

const PHOTOS = [
  { n: "g01", w: 1152, h: 648, cat: "Security", cap: "Security team on site" },
  { n: "g03", w: 1600, h: 1383, cat: "Events", cap: "Event team with hosts" },
  { n: "g02", w: 648, h: 1152, cat: "Security", cap: "On-site duty briefing" },
  { n: "g04", w: 1280, h: 570, cat: "Events", cap: "Event crew at venue" },
  { n: "g06", w: 1280, h: 1280, cat: "Security", cap: "Security guard line-up" },
  { n: "g08", w: 1400, h: 876, cat: "Housekeeping", cap: "Housekeeping team" },
  { n: "g05", w: 1280, h: 583, cat: "Events", cap: "Bouncer team" },
  { n: "g07", w: 991, h: 567, cat: "Security", cap: "Night shift briefing" },
  { n: "g09", w: 800, h: 640, cat: "Housekeeping", cap: "Housekeeping staff on duty" },
  { n: "g11", w: 912, h: 572, cat: "Events", cap: "Event security personnel" },
  { n: "g10", w: 921, h: 572, cat: "Housekeeping", cap: "Housekeeping crew" },
  { n: "g14", w: 1500, h: 1500, cat: "Security", cap: "Ceremonial guard team" },
  { n: "g12", w: 1600, h: 640, cat: "Security", cap: "Supervisor briefing the team" },
  { n: "g13", w: 1600, h: 900, cat: "Security", cap: "Security staff at client premises" },
];
const CATS = ["All", "Security", "Housekeeping", "Events"];
const src = (p) => `/gallery/${p.n}.jpg`;

const Tile = ({ p, i }) => (
  <motion.figure data-testid={`gallery-item-${p.n}`}
    initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, delay: (i % 3) * 0.08, ease: EASE }}
    className="group relative block w-full mb-4 sm:mb-6 break-inside-avoid overflow-hidden bg-[var(--navy)]">
    <img src={src(p)} alt={p.cap} width={p.w} height={p.h} loading="lazy" className="w-full h-auto transition-transform duration-[1.1s] ease-out group-hover:scale-105" />
    <div className="absolute inset-0 bg-[linear-gradient(180deg,transparent_50%,rgba(11,15,38,0.85)_100%)] opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
    <figcaption className="absolute left-0 right-0 bottom-0 p-5 text-white opacity-0 translate-y-3 group-hover:opacity-100 group-hover:translate-y-0 transition-[opacity,transform] duration-500">
      <span className="block text-[11px] font-bold uppercase tracking-[0.2em] text-[#ff6b70]">{p.cat}</span>
      <span className="block font-display italic font-extrabold uppercase text-xl leading-tight">{p.cap}</span>
    </figcaption>
    <span className="absolute left-0 top-0 h-[4px] w-0 bg-[var(--red)] group-hover:w-full transition-[width] duration-700" />
  </motion.figure>
);

export default function GalleryContent() {
  const [cat, setCat] = useState("All");
  const items = cat === "All" ? PHOTOS : PHOTOS.filter((p) => p.cat === cat);

  return (
    <>
      <section data-testid="gallery-section" className="bg-white py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-8">
          <div className="flex flex-wrap gap-2 sm:gap-3 mb-10" role="tablist">
            {CATS.map((c) => (
              <button key={c} type="button" role="tab" aria-selected={cat === c} data-testid={`gallery-filter-${c.toLowerCase()}`} onClick={() => setCat(c)}
                className={`relative px-5 sm:px-6 py-2.5 text-xs sm:text-sm font-bold uppercase tracking-wider btn-cut transition-colors duration-300 ${cat === c ? "bg-[var(--navy)] text-white" : "bg-[var(--paper)] text-slate-700 hover:text-[var(--red)]"}`}>
                {c}
              </button>
            ))}
          </div>
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 sm:gap-6">
            {items.map((p, i) => <Tile key={p.n} p={p} i={i} />)}
          </div>
        </div>
      </section>
      <Closing testId="gallery-closing-cta" lead="See the difference" accent="on your site"
        text="Talk to us about security, housekeeping or event support for your premises." />
    </>
  );
}
